import React from 'react';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import commonMessages from '@atlassian/jira-servicedesk-common/src/i18n';
import messages from './messages';
import { ErrorContainer, FixButton } from './styled';

export type Props = {
	onFix: () => void;
	intl: IntlShape;
};

function MisconfiguredMessage(props: Props) {
	const {
		intl: { formatMessage },
		onFix,
	} = props;
	return (
		<ErrorContainer>
			<ErrorIcon
				color={token('color.icon.danger', colors.R300)}
				label={formatMessage(commonMessages.error)}
			/>
			{formatMessage(messages.runAsUserMisconfigured)}
			<FixButton>
				<Button onClick={onFix} appearance="link">
					{formatMessage(messages.selectAnotherUser)}
				</Button>
			</FixButton>
		</ErrorContainer>
	);
}

export default injectIntl(MisconfiguredMessage);
